import { render, staticRenderFns } from "./SignUpNotes.vue?vue&type=template&id=085d125d&scoped=true&"
import script from "./SignUpNotes.vue?vue&type=script&lang=js&"
export * from "./SignUpNotes.vue?vue&type=script&lang=js&"
import style0 from "./SignUpNotes.vue?vue&type=style&index=0&id=085d125d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085d125d",
  null
  
)

export default component.exports